import { VFC } from 'react';

import { LinkifyExternal } from 'dashboard/components/LinkifyExternal';
import ReportResultLayout from 'dashboard/components/ReportResult/ReportResultLayout';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { Backdrop } from 'dashboard/layouts/ShowViewLayoutV2';
import { ReportBusinessOnlinePresence } from 'dashboard/models/report/business-online-presence';
import Card from 'design-system/components/Card';
import Sticker from 'design-system/components/Sticker';

export interface BusinessOnlinePresenceProps {
  report: ReportBusinessOnlinePresence;
  isRedacted: boolean;
  multiCardFormat: boolean;
}

const BusinessClassification: VFC<BusinessOnlinePresenceProps> = ({
  report,
  isRedacted,
  multiCardFormat = false,
}: BusinessOnlinePresenceProps) => {
  const homepage = report.attributes.result?.homepage ?? '';
  const screenshotUrl = report.attributes.result?.['screenshot-url'] ?? '';

  const loading = ['submitted', 'pending'].includes(report.attributes.status);
  const noMatchFound = report.attributes.status === 'ready' && !homepage;

  const reportResult = isRedacted ? (
    <Sticker>Redacted</Sticker>
  ) : loading ? (
    <Backdrop>
      <LoadingIndicator />
    </Backdrop>
  ) : noMatchFound ? (
    <p>No business homepage found for the provided input.</p>
  ) : (
    <>
      <LinkifyExternal>{homepage}</LinkifyExternal>
      {screenshotUrl && <img src={screenshotUrl} width='900px' height='470px' />}
    </>
  );

  return (
    <ReportResultLayout multiCardFormat={multiCardFormat}>
      <>
        <Card.Title>Business Homepage</Card.Title>
        {reportResult}
      </>
    </ReportResultLayout>
  );
};

export default BusinessClassification;
